import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useError = () => {
  const navigate = useNavigate();

  const error = async () => {
    toast.error("An error occurred, please try again");
    navigate("/login");
  };

  return { error };
};
